// extracted by mini-css-extract-plugin
export default {"box":"Navbar_box__0ADT0","logo":"Navbar_logo__78SW2","nav_link":"Navbar_nav_link__EZqK5","active":"Navbar_active__eG7Hh"};